import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from 'semantic-ui-react';
import {arrayToGrid} from "utils/DBUtils";

const ItemGrid = (props) => (
    <Grid columns={props.colCount} className="db-item-grid">
        {arrayToGrid(props.items, props.colCount).map((row, index) => (
            <Grid.Row key={index}>
                {row.map((item, index) => (
                    <Grid.Column key={ (item.id || index) }>
                        {props.cellFunc(item)}
                    </Grid.Column>
                ))}
            </Grid.Row>
        ))}
    </Grid>
);

export const propShape = {
    items: PropTypes.array.isRequired,
        colCount: PropTypes.number.isRequired,
        rowCount: PropTypes.number.isRequired,
        cellFunc: PropTypes.func.isRequired // TODO: Default?
};

ItemGrid.propTypes = propShape;

export default ItemGrid;



// WEBPACK FOOTER //
// ./public/components/common/ItemGrid.jsx